import { createElement, memo, useRef, useEffect, useMemo, useCallback, useState } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import TopView from '@max/leez-top-view';
import Image from "@max/leez-image";
import ModalBaseContainer from '@max/leez-modal-base-container';
import './index.scss';
import { getFullScreenSize } from "@/utils/layout";
import { Animated } from '@max/mbc-animated';
import AnimatedView from '@max/mbc-animate-view';
import VapView from '../vap-view';
import { PACKAGE_PRIZE_VAP, BID_MAP, BID_TYPE } from '../../constants';
import { getPrizeModalInfo } from '@/utils';
const PackagePrizeModal = ({ visible, prize, onClose, onGoToUse, lxReport, goToAnchor, realPackagePrizeUuids = [] }) => {
    const { fullScreenHeight, fullScreenWidth } = getFullScreenSize();
    const opacity = useRef(new Animated.Value(0));
    const [isUseAnimated, setIsUseAnimated] = useState(false);
    useEffect(() => {
        if (visible) {
            // 弹窗曝光上报
            lxReport === null || lxReport === void 0 ? void 0 : lxReport(BID_MAP.PACKAGE_MODAL_MV, BID_TYPE.MV);
        }
        else {
            opacity.current.setValue(0);
        }
    }, [visible, lxReport]);
    const prizeModalInfo = useMemo(() => getPrizeModalInfo((prize === null || prize === void 0 ? void 0 : prize.userSubPrizeInfoList) || []), [prize === null || prize === void 0 ? void 0 : prize.userSubPrizeInfoList]);
    // console.log('prizeModalInfo', prizeModalInfo);
    const { title, isPackage, desc } = prizeModalInfo || {};
    const renderRealPackagePrizeContent = useCallback(() => {
        return <View className="package-prize-modal-content-wrap">
        <View>
          <Image source={{
            uri: 'https://p0.meituan.net/ingee/fa96b0b5f58faf3bcf5728d40520cacb28066.png'
        }} style={{
            width: '452rpx',
            height: '113rpx',
            marginBottom: '33rpx'
        }} borderRadius={0}/>
        </View>
        
        <Image className="package-prize-modal-content" source={{
            uri: 'https://p0.meituan.net/ingee/be1acdf207e09c26835a5988b8283f91209842.png'
        }} style={{
            width: '682rpx',
            height: '522rpx'
        }} borderRadius={0}>
          <View className="package-prize-modal-content-inner">
            <Text className="package-prize-modal-title">{title}</Text>
            <Text className="package-prize-modal-desc" numberOfLines={1}>{desc}</Text>

            
            <Image className="package-prize-modal-action-btn" source={{
            uri: 'https://p0.meituan.net/ingee/e2557fd9ea694002136ccab8fc0c37d719817.png'
        }} style={{
            width: '450rpx',
            height: '96rpx',
            marginTop: '43rpx',
            marginLeft: '-25rpx'
        }} borderRadius={0} onPress={() => {
            lxReport === null || lxReport === void 0 ? void 0 : lxReport(BID_MAP.PACKAGE_MODAL_MC, BID_TYPE.MC);
            goToAnchor === null || goToAnchor === void 0 ? void 0 : goToAnchor();
        }}/>
          </View>
        </Image>
        
        <Image onPress={onClose} source={{
            uri: 'https://p0.meituan.net/ingee/94047ffc6fa8ede65644e7a2653da1691779.png'
        }} style={{
            width: '48rpx',
            height: '48rpx',
            marginTop: '52rpx',
            marginLeft: '-30rpx'
        }} className="package-prize-modal-close-btn"/>
      </View>;
    }, [title, desc, goToAnchor, onClose, lxReport]);
    const userSubPrizeInfoList = (prize === null || prize === void 0 ? void 0 : prize.userSubPrizeInfoList) || [];
    const prizeItem = userSubPrizeInfoList[0];
    const renderCommonPrizeContent = useCallback(() => {
        // let title = '';
        let desc = '包含酒店周边游券、清明提前订券包';
        return <View className="package-prize-modal-content-wrap">
        <View>
          <Image source={{
            uri: 'https://p0.meituan.net/ingee/6656c16ab5486df0a56f21ea0d69fdc119641.png'
        }} style={{
            width: '312rpx',
            height: '96rpx',
            marginBottom: '36rpx'
        }} borderRadius={0}/>
        </View>
        
        <Image className="package-prize-modal-content" source={{
            uri: 'https://p0.meituan.net/ingee/31e0714d00c4d7bc9a79a176b121a40c210376.png'
        }} style={{
            width: '682rpx',
            height: '522rpx'
        }} borderRadius={0}>
          <View className="package-prize-modal-content-inner">
            
            <Text className="package-prize-modal-desc" numberOfLines={1} style={{
            marginTop: '327rpx'
        }}>{desc}</Text>

            
            <Image className="package-prize-modal-action-btn" source={{
            uri: 'https://p0.meituan.net/ingee/e2557fd9ea694002136ccab8fc0c37d719817.png'
        }} style={{
            width: '450rpx',
            height: '96rpx',
            marginTop: '43rpx',
            marginLeft: '-25rpx'
        }} borderRadius={0} onPress={() => {
            lxReport === null || lxReport === void 0 ? void 0 : lxReport(BID_MAP.PACKAGE_MODAL_MC, BID_TYPE.MC);
            onGoToUse === null || onGoToUse === void 0 ? void 0 : onGoToUse(prizeItem);
        }}/>
          </View>
        </Image>
        
        <Image onPress={onClose} source={{
            uri: 'https://p0.meituan.net/ingee/94047ffc6fa8ede65644e7a2653da1691779.png'
        }} style={{
            width: '48rpx',
            height: '48rpx',
            marginTop: '52rpx',
            marginLeft: '-30rpx'
        }} className="package-prize-modal-close-btn"/>
      </View>;
    }, [prizeItem, onGoToUse, onClose, lxReport]);
    const { uuid } = prize || {};
    const isRealPackagePrize = uuid && realPackagePrizeUuids.includes(uuid);
    useEffect(() => {
        setIsUseAnimated(!!isRealPackagePrize);
    }, [isRealPackagePrize]);
    if (!visible || !prize) {
        return null;
    }
    let renderContent = renderCommonPrizeContent;
    if (isRealPackagePrize) {
        renderContent = renderRealPackagePrizeContent;
    }
    return <TopView>
      <ModalBaseContainer visible={visible} contentStyle={{
        width: '750rpx',
        height: fullScreenHeight,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
    }}>
        <VapView x-if={isUseAnimated} {...PACKAGE_PRIZE_VAP} isFullScreen widthHeightRatio={750 / 1642} height={fullScreenHeight} width={fullScreenWidth} style={{
        bottom: 0,
        left: 0,
        position: 'absolute'
    }} keepLastFrame loop={false} playPointActions={[{
            action: () => {
                Animated.timing(opacity.current, {
                    toValue: 1,
                    duration: 1000,
                    useNativeDriver: true,
                    easing: Animated.Easing.bezier(0.25, 0.1, 0.25, 1.0)
                }).start();
            },
            microseconds: 100
        }]}/>
        <AnimatedView x-if={isUseAnimated} viewId="package-prize-modal-container" style={{
        opacity: opacity.current,
        width: '750rpx',
        height: fullScreenHeight,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    }}>
          {renderContent()}
        </AnimatedView>

        <View x-if={!isUseAnimated} style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '750rpx',
        height: fullScreenHeight
    }}>
          {renderContent()}
        </View>
      </ModalBaseContainer>
    </TopView>;
};
export default memo(PackagePrizeModal);
